import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, HostBinding, NgModule } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i2 from '@angular/router';
import { NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as i1 from '@eui/core';
import { CommonModule } from '@angular/common';

class EuiDimmerComponent {
    constructor(asService, router) {
        this.asService = asService;
        this._isDimmerActive = false;
        /** @deprecated it will be removed in next eUI version */
        this.e2eAttr = 'eui-dimmer';
        this._DEBUG = false;
        // The events stream contains all the navigation events including the NavigationStart event
        // which gives information about what initiated the navigation sequence
        router.events
            .pipe(filter((event) => {
            return (event instanceof NavigationStart);
        }))
            .subscribe((event) => {
            if (this._DEBUG) {
                console.group('NavigationStart Event');
                // Every navigation sequence is given a unique ID.
                console.log('navigation id:', event.id);
                console.log('route:', event.url);
                // The 'navigationTrigger' will be one of:
                // - imperative : ie. user clicked on a link
                // - popstate : browser controlled change such as Back button which gets a new, unique ID
                // - hashchange
                // @See: https://angular.io/api/router/NavigationStart
                console.log('trigger:', event.navigationTrigger);
                // The 'restoredState' property is defined when the navigation event is triggered by a 'popstate' event
                // It will contain the ID of the previous navigation event from which the browser is returning
            }
            if (event.restoredState) {
                this.asService.setDimmerActiveState(false);
                this._isDimmerActive = false;
                if (this._DEBUG) {
                    console.warn('restoring navigation id:', event.restoredState.navigationId);
                }
            }
            if (this._DEBUG) {
                console.groupEnd();
            }
        });
    }
    get isDimmerActive() { return this._isDimmerActive; }
    set isDimmerActive(value) { this._isDimmerActive = coerceBooleanProperty(value); }
    get cssClasses() {
        return [
            'eui-dimmer',
            this._isDimmerActive ? `eui-dimmer--active` : ``,
        ].join(' ').trim();
    }
}
/** @nocollapse */ EuiDimmerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDimmerComponent, deps: [{ token: i1.UxAppShellService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ EuiDimmerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: EuiDimmerComponent, selector: "eui-dimmer", inputs: { isDimmerActive: "isDimmerActive", e2eAttr: "e2eAttr" }, host: { properties: { "class": "this.cssClasses", "attr.data-e2e": "this.e2eAttr" } }, ngImport: i0, template: '', isInline: true, styles: [".eui-dimmer{animation:none;background-color:#00000026;height:100vh;left:0;opacity:0;position:fixed;top:0;width:0;z-index:var(--eui-base-z-index-overlay)}.eui-dimmer--active{animation:dimmer-fadeIn var(--eui-base-animation-duration-fast);opacity:1;width:100%}.eui-dimmer:not(.eui-dimmer--active){animation:dimmer-fadeOut var(--eui-base-animation-duration-fast)}@keyframes dimmer-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes dimmer-fadeOut{0%{opacity:1}to{opacity:0}}\n"], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDimmerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'eui-dimmer', template: '', changeDetection: ChangeDetectionStrategy.Default, encapsulation: ViewEncapsulation.None, styles: [".eui-dimmer{animation:none;background-color:#00000026;height:100vh;left:0;opacity:0;position:fixed;top:0;width:0;z-index:var(--eui-base-z-index-overlay)}.eui-dimmer--active{animation:dimmer-fadeIn var(--eui-base-animation-duration-fast);opacity:1;width:100%}.eui-dimmer:not(.eui-dimmer--active){animation:dimmer-fadeOut var(--eui-base-animation-duration-fast)}@keyframes dimmer-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes dimmer-fadeOut{0%{opacity:1}to{opacity:0}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.UxAppShellService }, { type: i2.Router }]; }, propDecorators: { isDimmerActive: [{
                type: Input
            }], cssClasses: [{
                type: HostBinding,
                args: ['class']
            }], e2eAttr: [{
                type: HostBinding,
                args: ['attr.data-e2e']
            }, {
                type: Input
            }] } });

class EuiDimmerModule {
}
/** @nocollapse */ EuiDimmerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDimmerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EuiDimmerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiDimmerModule, declarations: [EuiDimmerComponent], imports: [CommonModule], exports: [EuiDimmerComponent] });
/** @nocollapse */ EuiDimmerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDimmerModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDimmerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [EuiDimmerComponent],
                    declarations: [EuiDimmerComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EuiDimmerComponent, EuiDimmerModule };
